import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import { deepOrange, green } from "@material-ui/core/colors";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import EditIcon from "@material-ui/icons/Edit";
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import ImageUploader from "react-images-upload";
import { useDispatch } from "react-redux";
import {
	imageSelectionActions,
	imageUploadActions,
} from "../../actions/fileUploadActions";
import { saveUserStatus } from "../../actions/manageUserStatus";
import { addLineBreaks } from "../../actions/tool";
import { IP } from "../../config/IP";
import store from "../../store/createStore";
import EditStatusForm from "../EditStatusForm";
import "./Style.css";

const StyledBadge = withStyles((theme) => ({
	root: {
		display: "flex",
		"& > *": {
			margin: theme.spacing(1),
		},
	},
	small: {
		width: theme.spacing(3),
		height: theme.spacing(3),
	},
	large: {
		width: theme.spacing(7),
		height: theme.spacing(7),
	},
	badge: {
		backgroundColor: "#44b700",
		color: "#44b700",
		boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
		"&::after": {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			borderRadius: "50%",
			animation: "$ripple 1.2s infinite ease-in-out",
			border: "1px solid currentColor",
			content: '""',
		},
	},
	"@keyframes ripple": {
		"0%": {
			transform: "scale(.8)",
			opacity: 1,
		},
		"100%": {
			transform: "scale(2.4)",
			opacity: 0,
		},
	},
}))(Badge);

const SmallAvatar = withStyles((theme) => ({
	root: {
		width: 22,
		height: 22,
		border: `2px solid ${theme.palette.background.paper}`,
	},
}))(Avatar);

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		"& > *": {
			margin: theme.spacing(1),
		},
		justifyContent: "center",
		alignItems: "center",
	},
	avatar: {
		width: 60,
		height: 60,
		top: 5,
		bottom: 5,
		justifyContent: "center",
		alignItems: "center",
	},

	small: {
		width: theme.spacing(3),
		height: theme.spacing(3),
	},
	large: {
		width: theme.spacing(7),
		height: theme.spacing(7),
	},
	square: {
		color: theme.palette.getContrastText(deepOrange[500]),
		backgroundColor: deepOrange[500],
		width: 100,
		height: 100,
	},
	rounded: {
		color: "#fff",
		backgroundColor: green[500],
		width: 100,
		height: 100,
	},
}));

const UserProfile = forwardRef((props, ref) => {
	const refediting = useRef(null);

	const dispatch = useDispatch();
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);
	const [pictures, setPictures] = React.useState([]);
	const [photo, setPhoto] = React.useState(props.photo);
	const [editScreen, setEditScreen] = React.useState();
	/*const [statusError, statusError] = React.useState({
		status: null,
		reason: null,
		fromDate: null,
		toDate: null,
		userActing: null,
	});*/
	let statusError = {
		status: null,
		reason: null,
		fromDate: null,
		toDate: null,
		userActing: null,
	};

	const [status, setStatus] = React.useState();

	const [screen, setScreen] = React.useState();

	const onDrop = (picture) => {
		setPictures(pictures.concat(picture));
		dispatch(imageSelectionActions(picture));

		var reader = new FileReader();
		reader.onload = function (e) {
			var base64data = e.target.result;

			setPhoto(base64data);
		};

		reader.readAsDataURL(picture[picture.length - 1]);
		console.log("onDrop pictures=", pictures);
		//handleClose();
	};
	const handleClickOpen = (value) => {
		setOpen(true);
		setScreen(value);
	};

	const handleClose = () => {
		setOpen(false);
	};
	const handleEditSave = (save) => {
		let state = store.getState();
		let username = state.auth.user.allUser.find(
			(x) => x._id === state.auth.user.usernameId
		).username;

		console.log("handleEditSave in body save=", save);
		if (save === 1) {
			if (state.imageUpload.file) {
				console.log(
					"state.imageUpload.file.file=",
					state.imageUpload.file.file
				);
				try {
					let inputs = {
						url: IP.nodeServer + "api/uploadImageProfile",
						data: [
							{ name: "file", value: state.imageUpload.file.file[0] },

							{
								name: "username",
								value: username,
							},
						],
					};

					dispatch(imageUploadActions(inputs));
				} catch (e) {}
				var reader = new FileReader();
				reader.onload = function (e) {
					var base64data = e.target.result;

					setPhoto(base64data);
				};
				//console.log("state.imageUpload.file=", state.imageUpload.file.file);
				reader.readAsDataURL(state.imageUpload.file.file[0]);
				if (store.getState().imageUpload.isUploaded) {
					var buffer = Buffer.from(
						store.getState().imageUpload.response.image.data.response.picture
							.data
					);

					setPhoto("data:image/png;base64," + buffer.toString("base64"));
					console.log(
						"in use Effect store.getState().imageUpload.response.image",
						store.getState().imageUpload.response.image
					);
				}

				props.setnewProfilePictureFx(true);
				console.log("UserProfile run of props.setnewProfilePictureFx Ok");

				handleClose();
			}

			console.log("handlesaveProfile clicked!");
		}

		if (save === 2) {
			console.log("handleEditSave status=", status);
			console.log("status.action=", status.action);
			let savecond = true;

			if (!status.action) {
				if (!status.fromDate) {
					statusError = { ...statusError, fromDate: "is Empty" };
					savecond = false;
				}
				if (!status.reason) {
					statusError = { ...statusError, reason: "is Empty" };
					savecond = false;
				}
				if (!status.status) {
					statusError = { ...statusError, status: "is Empty" };
					savecond = false;
				}

				if (!status.toDate) {
					statusError = { ...statusError, stoDate: "is Empty" };
					savecond = false;
				}
				if (!status.userActing) {
					statusError = { ...statusError, userActing: "is Empty" };
					savecond = false;
				}
				console.log("handleEditSave statusError=", statusError);
				refediting.current.handleShowStatusError(statusError);
			} else {
				savecond = true;
				setStatus({
					action: true,
					fromDate: null,
					reason: "Present",
					status: 1,
					statusId: 1,
					toDate: null,
					userActing: "",
				});
			}
			let inputs = {
				url: IP.nodeServer + "api/saveUserStatus",
				method: "POST",
				data: [
					{
						name: "status",
						value: status,
					},
					{ name: "username", value: username },
				],
			};
			console.log("saveUserStatus(inputs)=", inputs);
			if (savecond) {
				dispatch(saveUserStatus(inputs));
				console.log("condition is true to save aveUserStatus");
				props.setnewProfilePictureFx(true);
				handleClose();
			}
		}
	};

	useImperativeHandle(ref, () => {
		return {
			status: status,
			photo: photo,
		};
	});
	React.useEffect(() => {
		console.log("useEffect handleEditSave statusError=", statusError);
	}, [statusError]);

	/*
	statusId: reasonActingValue.id,
			status: reasonActingValue.action,
			reason: reasonActingValue.title,
			fromDate: selectionRange.startDate,
			toDate: selectionRange.endDate,
			userActing: userActingValue.title,
	*/
	const handlesetStatus = (newstatus) => {
		setStatus(newstatus);
		console.log("handleEditSave handlesetStatus status", newstatus);

		//props.setStatus
	};
	return (
		<aside>
			<Card className={classes.root}>
				<CardActionArea>
					<Avatar
						alt={props.name}
						src={photo}
						variant="circle"
						className={classes.avatar}
					/>

					<CardContent>
						<Typography gutterBottom variant="h5" component="h2">
							{props.name}
						</Typography>
						<Typography variant="body2" color="textSecondary" component="p">
							{addLineBreaks(props.office_name)}
						</Typography>
					</CardContent>
				</CardActionArea>
				<CardActions>
					<Button
						color="secondary"
						aria-label="Edit Picture"
						onClick={() => handleClickOpen(1)}
					>
						Photo
						<EditIcon />
					</Button>

					<Button
						color="secondary"
						aria-label="Edit Status"
						onClick={() => handleClickOpen(2)}
						size="small"
					>
						Status
						<EditIcon />
					</Button>
				</CardActions>
			</Card>

			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					{screen === 1 ? "Photo" : "Status"}
				</DialogTitle>
				{screen === 1 ? (
					<DialogContent>
						<DialogContentText>Upload new Profile Image.</DialogContentText>
						<div className={classes.root}>
							<Avatar
								alt={props.name}
								src={photo}
								variant="circle"
								className={classes.avatar}
							/>
						</div>

						<ImageUploader
							withIcon={true}
							buttonText="Choose images"
							onChange={onDrop}
							imgExtension={[".jpg", ".gif", ".png", ".gif"]}
							maxFileSize={5242880}
						/>
					</DialogContent>
				) : (
					<DialogContent>
						<DialogContentText>Edit status.</DialogContentText>
						<EditStatusForm
							setStatus={handlesetStatus}
							error={statusError}
							ref={refediting}
						/>
					</DialogContent>
				)}

				<DialogActions>
					<Button
						onClick={() => {
							handleEditSave(screen);
							console.log("handleEditSave paramter screen=", screen);
						}}
						color="primary"
					>
						Save
					</Button>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
				</DialogActions>
			</Dialog>
		</aside>
	);
});

export default UserProfile;
